import { getOSFromUserAgent } from './OS'

export const MACOS_KB_SIZE = 1000
export const PC_KB_SIZE = 1024

export enum FileExtension {
  BMP = 'bmp',
  CSV = 'csv',
  DOC = 'doc',
  DOCX = 'docx',
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  GIF = 'gif',
  PDF = 'pdf',
  XLS = 'xls',
  XLSX = 'xlsx',
}

export const getFileExtension = (fileName: string): FileExtension | undefined => {
  const extensionValue = fileName.substring(fileName.lastIndexOf('.') + 1)?.toLowerCase()
  if (extensionValue?.length < 3) {
    return
  }
  const extensions: Array<FileExtension> = Object.keys(FileExtension)
    .filter(extensionKey => FileExtension[extensionKey as keyof typeof FileExtension] === extensionValue)
    .map(extensionKey => FileExtension[extensionKey as keyof typeof FileExtension])
  if (!extensions || extensions.length < 1 || extensions.length > 1) {
    return
  }
  return extensions[0]
}

export const getMaxFileSize = (maxFileSize: number) => {
  const OS = getOSFromUserAgent()
  switch (OS) {
    case 'Mac OS':
      return Math.pow(MACOS_KB_SIZE, 2) * maxFileSize
    case 'Windows':
    case 'Linux':
    default:
      return Math.pow(PC_KB_SIZE, 2) * maxFileSize
  }
}
